export * from './SettingsView';


// WEBPACK FOOTER //
// ./src/components/settings/index.tsx